import { useQuery, QueryClient } from "react-query";
import { apiRequest } from "@/utils/api";
export function useFetch(url: string, QN: string) {
  const queryClient = new QueryClient()
  return useQuery([QN, QN], () => apiRequest(url), {
    initialData: () => {
      // Use a todo from the 'todos' query as the initial data for this todo query
      return queryClient.getQueryData([QN])
    },
    refetchOnWindowFocus: false,
    cacheTime: 100000,
    staleTime: 10000,
  });
}
